import { toast } from 'react-toastify';
import ApiBase from "./base";
import i18n from "../translations";
import { jsonToQueryString } from '../shared/utils';

export const _VEHICLE_TYPE_URL = "vehicle-type";

export async function getVehicleTypeList(params) {
    const response = await ApiBase.get(`${_VEHICLE_TYPE_URL}?${jsonToQueryString(params)}`);

    return response;
}

export async function getVehicleTypeDetail(id) {
    const response = await ApiBase.get(`${_VEHICLE_TYPE_URL}/${id}`);

    return response;
}

export async function createVehicleType(params) {
    const response = await ApiBase.post(`${_VEHICLE_TYPE_URL}`, params);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_CREATE_VEHICLE_TYPE"))

    return response;
}

export async function updateVehicleType(id, params) {
    const response = await ApiBase.patch(`${_VEHICLE_TYPE_URL}/${id}`, params);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_UPDATE_VEHICLE_TYPE"))

    return response;
}